import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getAccountsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/accounts`;

const getAccountByIdUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/accounts/${aId}`;

const addAccountUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/accounts`;

const updateAccountUrl = (aId, cId, sId) => `/companies/${cId}/subcompanies/${sId}/accounts/${aId}`;

const toggleAccountUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/accounts/${aId}/toggle`;

const formConfigUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/accounts/form_config`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getAccountsUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(accountId, companyId, subcompanyId) {
    const url = getAccountByIdUrl(accountId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, account) {
    const url = addAccountUrl(companyId, subcompanyId);

    account._customFields = account.customFields;
    account._financialDepreciation = account.financialDepreciation;
    account._fiscalDepreciation = account.fiscalDepreciation;
    delete account.customFields;
    delete account.financialDepreciation;
    delete account.fiscalDepreciation;

    return this.axios
      .post(url, account, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(accountId, companyId, subcompanyId, account) {
    const url = updateAccountUrl(accountId, companyId, subcompanyId);

    account._customFields = account.customFields;
    account._financialDepreciation = account.financialDepreciation;
    account._fiscalDepreciation = account.fiscalDepreciation;

    delete account.customFields;
    delete account.financialDepreciation;
    delete account.fiscalDepreciation;

    return this.axios
      .put(url, account, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(accountId, companyId, subcompanyId) {
    const url = toggleAccountUrl(accountId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  formConfig(companyId, subcompanyId) {
    const url = formConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/accounts.api.js